import React, { useState, useEffect } from "react";
import moment from "moment";
import "moment/locale/pt";
import { OkCancelRow } from "./Buttons";

const monthsShort = [
  "Jan",
  "Fev",
  "Mar",
  "Abr",
  "Mai",
  "Jun",
  "Jul",
  "Ago",
  "Set",
  "Out",
  "Nov",
  "Dez",
];

const CustomMonthPicker = ({
  defaultMonth,
  onChange,
  onClose,
  minDate,
  maxDate,
  blockedMonths = [],
}) => {
  const isMonthDisabled = (year, monthIndex) => {
    if (minDate && year < moment(minDate).year()) return true;
    if (maxDate && year > moment(maxDate).year()) return true;
    if (
      minDate &&
      year === moment(minDate).year() &&
      monthIndex < moment(minDate).month()
    )
      return true;
    if (
      maxDate &&
      year === moment(maxDate).year() &&
      monthIndex > moment(maxDate).month()
    )
      return true;
    if (
      blockedMonths.some((m) => m.year === year && m.month === monthIndex + 1)
    )
      return true;
    return false;
  };

  const [state, setState] = useState({
    currentYear: defaultMonth
      ? moment(defaultMonth.from || defaultMonth).year()
      : moment().year(),
    month: defaultMonth
      ? moment(defaultMonth.from || defaultMonth).month()
      : null,
  });

  useEffect(() => {
    if (defaultMonth) {
      setState({
        currentYear: moment(defaultMonth.from || defaultMonth).year(),
        month: moment(defaultMonth.from || defaultMonth).month(),
      });
    }
  }, [defaultMonth]);

  const handleMonthSelect = (monthIndex) => {
    if (isMonthDisabled(state.currentYear, monthIndex)) return;
    setState((prev) => ({ ...prev, month: monthIndex }));
  };

  const onOk = () => {
    if (state.month !== null) {
      const from = moment({
        year: state.currentYear,
        month: state.month,
        day: 1,
      })
        .startOf("day")
        .format("YYYY-MM-DD");

      const to = moment({ year: state.currentYear, month: state.month })
        .endOf("month")
        .format("YYYY-MM-DD");

      onChange({ from, to });
    }
  };

  const onCancel = () => {
    if (onClose) onClose();
  };

  return (
    <div className="flex flex-col items-center w-full max-w-[24rem]">
      <p className="text-center text-sm text-gray-500 mb-4 px-4">
        Selecione um mês para analisar os consumos
      </p>

      <div className="flex justify-between items-center mb-4 w-full px-8">
        <button
          onClick={() =>
            setState((p) => ({ ...p, currentYear: p.currentYear - 1 }))
          }
          className="text-btn-tertiary text-2xl font-bold"
        >
          {"<"}
        </button>
        <span className="font-medium text-white text-base bg-btn-primary rounded-full py-1 px-4 shadow-sm">
          {state.currentYear}
        </span>
        <button
          onClick={() =>
            setState((p) => ({ ...p, currentYear: p.currentYear + 1 }))
          }
          className="text-btn-tertiary text-2xl font-bold"
        >
          {">"}
        </button>
      </div>

      <div className="grid grid-cols-3 gap-3 mb-6 px-4 w-full">
        {monthsShort.map((monthName, index) => {
          const disabled = isMonthDisabled(state.currentYear, index);
          const isSelected = state.month === index;

          return (
            <button
              key={monthName}
              onClick={() => handleMonthSelect(index)}
              disabled={disabled}
              className={`py-2 rounded-full text-center transition-colors ${
                disabled
                  ? "text-gray-300 cursor-not-allowed"
                  : isSelected
                    ? "bg-btn-tertiary text-white font-bold"
                    : "text-gray-600 hover:bg-gray-100"
              }`}
            >
              {monthName}
            </button>
          );
        })}
      </div>

      <OkCancelRow
        className="pb-2 justify-center"
        onOk={onOk}
        onCancel={onCancel}
      />
    </div>
  );
};

export default CustomMonthPicker;
